import { useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { isZapSoundOn, setZapSoundOn } from "../lib/zapSound";

/** Tiny toggle for the channel-change jingle sound (persisted preference). */
export const ZapSoundToggle = () => {
  const [on, setOn] = useState(isZapSoundOn);
  const toggle = () => { setZapSoundOn(!on); setOn(!on); };
  return (
    <button
      type="button"
      onClick={toggle}
      data-testid="zap-sound-toggle"
      title={on ? "Jingle de zapping : son activé" : "Jingle de zapping : muet"}
      aria-pressed={on}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-[10px] uppercase tracking-widest transition-colors ${on ? "border-[color:var(--accent)]/50 text-[color:var(--accent)]" : "border-[color:var(--border)] text-[color:var(--text-muted)] hover:text-white"}`}
    >
      {on ? <Volume2 className="w-3 h-3" /> : <VolumeX className="w-3 h-3" />} Jingle
    </button>
  );
};
